export const REGULATION_PERIOD_COUNT = 3;
export const MAX_HOCKEY_PERIOD = 32767;
export const MAX_HOCKEY_PERIOD_MINUTES = 20;
export const MAX_HOCKEY_SECOND = 59;

export function getHockeyPeriodPhase(period) {
    const parsedPeriod = Number(period);
    if (!Number.isInteger(parsedPeriod) || parsedPeriod < 1 || parsedPeriod > MAX_HOCKEY_PERIOD) {
        return null;
    }
    return parsedPeriod <= REGULATION_PERIOD_COUNT ? "regulation" : "overtime";
}

export function getHockeyPeriodOptions(events = []) {
    const options = new Set([1, 2, 3, 4]);
    let hasOvertimeEvent = false;
    events.forEach((event) => {
        const period = Number(event.period);
        if (Number.isInteger(period) && period >= 1 && period <= MAX_HOCKEY_PERIOD) {
            options.add(period);
            if (period > REGULATION_PERIOD_COUNT) hasOvertimeEvent = true;
        }
    });
    const latestPeriod = Math.max(...options);
    if (hasOvertimeEvent && latestPeriod < MAX_HOCKEY_PERIOD) options.add(latestPeriod + 1);
    return Array.from(options).sort((first, second) => first - second);
}

export function validateHockeyEventClock(period, minute, second) {
    const parsedPeriod = Number(period);
    const parsedMinute = Number(minute);
    const parsedSecond = Number(second);

    if (!getHockeyPeriodPhase(parsedPeriod)) return "invalidPeriod";
    if (!Number.isInteger(parsedMinute) || parsedMinute < 0 || parsedMinute > MAX_HOCKEY_PERIOD_MINUTES ||
        (parsedMinute === MAX_HOCKEY_PERIOD_MINUTES && parsedSecond > 0)) {
        return "invalidMinute";
    }
    if (!Number.isInteger(parsedSecond) || parsedSecond < 0 || parsedSecond > MAX_HOCKEY_SECOND) {
        return "invalidSecond";
    }
    return null;
}

export function isAllowedHockeyClockInput(field, value, minute) {
    if (value !== "" && !/^\d+$/.test(value)) return false;
    if (value === "") return true;

    const parsedValue = Number(value);
    if (field === "period") return parsedValue >= 1 && parsedValue <= MAX_HOCKEY_PERIOD;
    if (field === "minute") return parsedValue <= MAX_HOCKEY_PERIOD_MINUTES;
    if (field === "second") return parsedValue <= (String(minute) === "20" ? 0 : MAX_HOCKEY_SECOND);
    return false;
}
